export function formatDate(date, withoutHour = false) {
  const dateObj = new Date(date)
  let options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  }

  if (withoutHour) {
    options = { year: 'numeric', month: '2-digit', day: '2-digit' }
  }

  return dateObj.toLocaleString('en-US', options)
}